import './BasketWidget.css';
import {useEffect} from "react";
import BasketWidgetItem from "./BasketWidgetItem/BasketWidgetItem.jsx";
import {useLocation, useNavigate} from "react-router-dom";
import {useBasket} from "../../context/BasketContext/BasketContext.jsx";
import {generateCheckoutLink} from "../../CheckoutHandler.js";


export default function BasketWidget({ setDisplayBasketWidget, displayBasketWidget, basket }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { basketVersion, bumpBasketVersion } = useBasket();

    // Lock scroll when widget is visible
    useEffect(() => {
        document.documentElement.style.overflow = displayBasketWidget ? 'hidden' : 'auto';
        return () => {
            document.documentElement.style.overflow = 'auto';
        };
    }, [displayBasketWidget]);

    const checkout = async()=>{
        const checkoutURL = await generateCheckoutLink();
        window.location.href=checkoutURL.url;
    }


    // Close widget on URL change
    useEffect(() => {
        setDisplayBasketWidget(false);
    }, [location.pathname]);

    const calculateTotalPrice = ()=>{
        let sum=0;
        basket.forEach((item) => {
            sum+=(item.item.price * item.quantity);
        })
        return sum.toFixed(2);
    }

    return (
        <div className={`basket-widget-wrapper ${displayBasketWidget ? 'basket-widget-visible' : ''}`}>
            <div className="basket-widget-shadow" onClick={() => setDisplayBasketWidget(false)} />
            <div className="basket-widget-container">
                <div className="basket-widget-header">
                    <span>Twój koszyk</span>
                    <div
                        className="close-basket-button"

                        onClick={() => setDisplayBasketWidget(false)}
                    >
                        <img loading="lazy" src='/images/close-icon.webp' alt="" />

                    </div>
                </div>

                <div className="basket-widget-items">
                    {basket.map((item, index) => (
                        <BasketWidgetItem item={item} key={index} />
                    ))}
                </div>

                <div className="basket-widget-summary">
                    <span className="label">Cena całkowita:</span>
                    <span>{calculateTotalPrice()} zł</span>
                </div>

                <div className="basket-widget-actions">
                    <div
                        className="basket-button see-basket"
                        onClick={() => navigate('/koszyk')}
                    >
                        ZOBACZ KOSZYK
                    </div>
                    {basket.length===0 ? <div className="basket-button place-order-disabled">PRZEJDŹ DO ZAMÓWIENIA</div> : <div className="basket-button place-order" onClick={()=>{checkout()}}>PRZEJDŹ DO ZAMÓWIENIA</div>}
                </div>
            </div>
        </div>
    );
}
